import { render, staticRenderFns } from "./proxy-list.vue?vue&type=template&id=6688bf86&scoped=true&"
import script from "./proxy-list.vue?vue&type=script&lang=js&"
export * from "./proxy-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688bf86",
  null
  
)

export default component.exports